/** The per-visitor flags the server worked out for a page, shipped with it. */
export interface ServerFlags {
  /** The id they were evaluated for; they apply only if the browser settles on the same. */
  distinctId: string;
  values: Record<string, string | boolean>;
  /** Some value is its default, not an answer: rules not loaded yet, a flag not evaluable here,
   *  or the site's way back to browser-evaluated flags is on. */
  defaulted: boolean;
}

/** The page's flags stand only for the id they were worked out for, and only as answers.
 *  Otherwise the browser asks PostHog after load. */
export function serverFlagsStand({
  flags,
  distinctId,
}: {
  flags: ServerFlags | null | undefined;
  distinctId: string;
}): boolean {
  return flags != null && !flags.defaulted && flags.distinctId === distinctId;
}
